import React from 'react';
import { Check } from 'lucide-react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
const youBring = ['The book', 'Existing offers', 'Point of view', 'Judgment', 'Brand materials', 'A few focused working sessions'];
const weBuild = ['Reader strategy', 'Diagnostic & readout', 'Concept Guide', 'Interactive application', 'Reader signals', 'Offer routing', 'Sales enablement', 'Content & business assets', 'Copy', 'Design', 'Implementation', 'Launch support'];
export function DoneForYou() {
  return <SectionBand tone="paperDark" width="wide" data-id="element-697" data-mp="2f2kav0f75rjq">
      <div className="max-w-3xl" data-id="element-698" data-mp="20cv7cyjmtbga">
        <Reveal data-id="element-699" data-mp="20do374h1ygjn">
          <Eyebrow data-id="element-700" data-mp="20e68srplu748">Done for you</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-tight text-navy md:text-5xl" data-id="element-701" data-mp="25b6f93qd9bvv">
            You wrote the book.
            <br data-id="element-702" data-mp="1rbeyiv8gthe6" />
            <span className="italic text-seaglass" data-id="element-703" data-mp="1rcyfyp5uxyhj">
              We build the leverage around it.
            </span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid items-start gap-6 lg:grid-cols-[0.72fr_1.28fr] lg:gap-8" data-id="element-704" data-mp="1xu1kct4ieg9t">
        <Reveal delay={0.1} data-id="element-705" data-mp="1svgr5dnocwuv">
          <div className="rounded-3xl border border-gray-200 bg-paper p-7 md:p-8" data-id="element-706" data-mp="1su6r4ix9hell">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-text-muted" data-id="element-707" data-mp="27t0p40m5lrrj">
              You bring
            </p>
            <ul className="mt-5 space-y-3" data-id="element-708" data-mp="22txmsnxk5zn9">
              {youBring.map(item => <li key={item} className="flex items-start gap-3 text-text" data-id="element-709" data-mp="1f30km2vkegp7">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-text-muted/50" data-id="element-710" data-mp="1a4z1xj21wje9" />
                  <span className="leading-relaxed" data-id="element-711" data-mp="1otd21m831tr4">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.15} data-id="element-712" data-mp="1k1vbls3orbke">
          <div className="rounded-3xl border-2 border-seaglass bg-navy p-7 text-paper shadow-[0_30px_60px_-28px_rgba(26,40,56,0.6)] md:p-9" data-id="element-713" data-mp="1k1lme6qgt8fr">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-seaglass-light" data-id="element-714" data-mp="rehentzzmg0a">
              We build
            </p>
            <ul className="mt-5 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-715" data-mp="1h1lg0e5tcts4">
              {weBuild.map(item => <li key={item} className="flex items-start gap-3" data-id="element-716" data-mp="1l2nh70jajfwq">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-seaglass text-white" data-id="element-717" data-mp="1puyd7sawuhk0">
                    <Check className="h-3 w-3" strokeWidth={3} data-id="element-718" data-mp="1usgi97lt4cmq" />
                  </span>
                  <span className="leading-relaxed text-paper/90" data-id="element-719" data-mp="y4k7wkgyqdjy">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2} data-id="element-720" data-mp="174714izjgd1x">
        <p className="mx-auto mt-12 max-w-2xl text-center text-lg text-text-muted" data-id="element-721" data-mp="173xijggtp869">
          <span className="block" data-id="element-722" data-mp="1c3tcemvt3j83">You stay the author and the expert.</span>
          <span className="mt-1 block" data-id="element-723" data-mp="1c0xgt57fl6mt">
            You do not become a project manager or a tech manager.
          </span>
        </p>
      </Reveal>
    </SectionBand>;
}